import { routes as auth } from "../modules/auth";
import { routes as pages } from "../views/index";
export default [
    ...auth,
    ...pages,
];